/**
 * Set up routing for all Scene views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import scene views
// import SingleScene from './views/SingleScene.js.jsx';
// 
class SceneRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        {/* <YTRoute login={true} exact path="/scenes/:sceneId" component={SingleScene}/> */}
      </Switch>
    )
  }
}

export default SceneRouter;



// WEBPACK FOOTER //
// modules/scene/SceneRouter.js.jsx